import { Open } from '@drift-labs/icons';
import { DesktopNavDropdownContentProps } from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/types';
import NavItemTags from 'src/components/Navigation/NavItemTags';
import { DesktopNavigationOptionItem } from 'src/components/Navigation/types';
import { cj } from 'src/utils/classNames';

interface Props extends Pick<
	DesktopNavDropdownContentProps,
	'onClick' | 'currentNavSelection'
> {
	categoryOption: DesktopNavigationOptionItem;
}

export default function DesktopNavDropdownContentButton({
	categoryOption,
	onClick,
}: Props) {
	const {
		key,
		name,
		newTag,
		hotTag,
		tagLabel,
		handler,
		isExternalLink,
		description,
		icon: Icon,
	} = categoryOption;

	return (
		<button
			className={cj(
				'group flex gap-x-sm p-lg',
				'bg-menu-bg text-text-default hover:bg-button-secondary-bg',
				description ? 'items-start' : 'items-center'
			)}
			onClick={() => onClick(handler())}
			data-puppet-tag={key}
			data-testid={`nav-${key}`}
		>
			<Icon size={16} />

			<div className="flex flex-col gap-y-sm">
				<span className="flex items-center gap-x-xs typo-t3">
					{name}
					{isExternalLink && <Open autoSize />}
					<NavItemTags newTag={newTag} hotTag={hotTag} tagLabel={tagLabel} />
				</span>

				{description && (
					<div className="text-left typo-b4 text-text-secondary transition-colors group-hover:text-text-default">
						{description}
					</div>
				)}
			</div>
		</button>
	);
}
